import React, { useContext } from 'react'
import { LanguageContext } from '../../container/Language';
import Services from './Services';
import Title from '../Title';
import Disponibility from './Disponibility';

const About = () => {
    const { dictionary: { about: {aboutMeTitle, me, disponibility, services} } } = useContext(LanguageContext);

    return (
        <div className="card-inner animated active" id="about-card">
            <div className="card-wrap">

                <div className="content about">
                    <Title text={aboutMeTitle} />
                    <div className="row">
                        <div className="col col-d-6 col-t-6 col-m-12 border-line-v">
                            <div className="text-box" dangerouslySetInnerHTML={{__html: me}}>
                            </div>
                        </div>
                    </div>
                </div>

                { disponibility && (<div className="content disponibility">
                    <Title text={disponibility.title} />
                    <div className="row service-items border-line-v     ">
                       <Disponibility items={disponibility.items} />
                    </div>
                </div>) }
                

                <div className="content services">
                    <Title text={services.title} />
                    <div className="row service-items border-line-v">
                       <Services items={services.items} />
                    </div>
                </div>

            </div>
        </div>
    )
}

export default About